import { ReactNode } from 'react';
import { ACTIVITY_DETAILS_COLORS, ACTIVITY_DETAILS_TYPOGRAPHY } from './constants';

interface MetadataBadgeProps {
  icon: ReactNode;
  text: string;
}

/**
 * MetadataBadge Component
 * 
 * Icon + text metadata badge (duration, play type, prep needed).
 * Responsive: Text scales 14px → 15px → 16px.
 */
export default function MetadataBadge({ icon, text }: MetadataBadgeProps) {
  return (
    <div className="flex items-center gap-1">
      {icon}
      <span
        className={`${ACTIVITY_DETAILS_TYPOGRAPHY.metadata.weight} ${ACTIVITY_DETAILS_TYPOGRAPHY.metadata.sizeClasses}`}
        style={{
          fontFamily: 'DM Sans, sans-serif',
          color: ACTIVITY_DETAILS_COLORS.textSecondary,
        }}
      >
        {text}
      </span>
    </div>
  );
}
